<template>
  <div v-if="isClose" class="closeTxt">{{ gconfig.RegistStopWords }}</div>
  <template v-else>
    <img :src="gconfig.HomePictrue" class="hm" alt="" />
    <div class="loginB" v-show="(isWeX && openid) || !isWeX">
      <div class="logins">
        <h2 class="loginTit">注册/登录</h2>
        <div class="tabs" v-if="gconfig.IsEmailLogin === 'True'">
          <span
            @click="tabChange('dl')"
            :class="tabnow === 'dl' ? 'active' : ''"
            >手机号注册</span
          >
          <span
            @click="tabChange('gat')"
            :class="tabnow === 'gat' ? 'active' : ''"
            >邮箱注册</span
          >
        </div>
        <div class="loginFormbox" v-show="tabnow === 'dl'">
          <van-form ref="loginForm" @submit="onSubmit">
            <div class="formItem">
              <van-field
                v-model="form.mobile"
                name="mobile"
                label="手机号"
                placeholder="请输入手机号"
                :rules="[
                  {
                    required: true,
                    validator: validatorMobile,
                    message: '请输入正确的手机号'
                  }
                ]"
              />
            </div>
            <div class="formItem">
              <van-cell-group>
                <van-field
                  v-model="form.code"
                  center
                  clearable
                  name="code"
                  label="短信验证码"
                  placeholder="请输入短信验证码"
                  maxlength="4"
                  :rules="[
                    {
                      required: true,
                      validator: validatorCode,
                      message: '请输入正确的短信验证码'
                    }
                  ]"
                >
                  <template #button>
                    <van-button
                      style="width: 100%"
                      :disabled="btnTxt !== '发送验证码'"
                      plain
                      :color="mainColor"
                      @click="getSms"
                      round
                      size="small"
                      type="primary"
                      >{{ btnTxt }}</van-button
                    >
                  </template>
                </van-field>
              </van-cell-group>
            </div>
            <div
              :class="gconfig.MobilePageBottomText ? 'btnbox' : 'btnbox pad40'"
            >
              <van-button
                type="primary"
                :color="mainColor"
                native-type="submit"
              >
                注册/登录
              </van-button>
            </div>
            <div v-html="gconfig.MobilePageBottomText"></div>
          </van-form>
        </div>
        <!-- 邮箱 -->
        <div class="loginFormbox" v-show="tabnow === 'gat'">
          <van-form ref="loginFormG" @submit="onSubmitG">
            <div class="formItem">
              <van-field
                v-model="formG.Name"
                name="Name"
                label="姓名"
                placeholder="请输入正确的姓名"
                :rules="[
                  {
                    required: true,
                    validator: validatorName,
                    message: '请输入正确的姓名'
                  }
                ]"
              />
            </div>
            <div class="formItem">
              <van-field
                v-model="formG.Email"
                name="Email"
                label="邮箱"
                placeholder="请输入正确的邮箱"
                :rules="[
                  {
                    required: true,
                    validator: validatorEmail,
                    message: '请输入正确的邮箱'
                  }
                ]"
              />
            </div>
            <div class="btnbox pad40">
              <van-button
                type="primary"
                :color="mainColor"
                native-type="submit"
              >
                注册/登录
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </template>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api/index.js'
import { showLoadingToast, showToast } from 'vant'
import { regMobile, regEmail, regName } from '@/utils/regs.js'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
sessionStorage.clear()
const store = useStore()
const router = useRouter()
const route = useRoute()
// 保存入口路径
sessionStorage.setItem('enterPath', route.path)
if (route.query.source) {
  sessionStorage.setItem('source', route.query.source)
}
// 邀请参数
if (route.query.invitesource) {
  sessionStorage.setItem('invitesource', route.query.invitesource)
}
if (route.query.invitesourceID) {
  sessionStorage.setItem('invitesourceID', route.query.invitesourceID)
}
if (route.query.lan) {
  sessionStorage.setItem('lan', route.query.lan)
}
if (route.query.ExhCode) {
  store.commit('setExhCode', route.query.ExhCode)
} else {
  showToast({
    message: '展会参数缺失！',
    wordBreak: 'break-all',
    type: 'fail'
  })
}
const openid = computed(() => store.state.openid)
const isWeX = computed(() => store.state.isWeX)
const ExhCode = computed(() => {
  return store.state.ExhCode
})
const mainColor = computed(() => store.state.mainColor)
const form = ref({
  code: '',
  mobile: ''
})
// 校验手机号
const validatorMobile = (val) => {
  return regMobile.test(val)
}
// 校验验证码格式
const regCode = /^[0-9]{4}$/
const validatorCode = (val) => {
  return regCode.test(val)
}
const loginForm = ref()
// 登录
const onSubmit = () => {
  loginForm.value.validate().then((valid) => {
    if (!valid) {
      api
        .checkMobileLoginApi({
          mobile: form.value.mobile,
          smscode: form.value.code,
          ExhCode: ExhCode.value,
          OpenID: openid.value
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              // 邮箱已注册
              if (res.data.visitorID) {
                store.commit('setVisitorID', res.data.visitorID)
                sessionStorage.setItem('invitesourceID', res.data.visitorID)
                if (gconfig.value.SuccessPageVersion === 'V2') {
                  router.push({ path: '/successV2' })
                } else {
                  router.push({ path: '/success' })
                }
              }
            } else {
              sessionStorage.setItem('tabac', tabnow.value)
              store.commit('setLoginForm', form.value)
              router.push({ path: '/msg' })
            }
          }
        })
    }
  })
}
onMounted(() => {
  showLoadingToast({
    duration: 0,
    message: '加载中...',
    forbidClick: true
  })
  getToken()
})
const token = computed(() => {
  return store.state.token
})
const getToken = async () => {
  const res = await api.getTokenApi()
  store.commit('setToken', res.data.authorToken)
  alert("aaaaaaa")
  getOpenID()
  getGlobalConfig()
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
// console.log(gconfig.value)
const getGlobalConfig = async () => {
  const res = await api.getGConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const tmpObj = {}
    const resObj = JSON.parse(decryptionECB(res.data.configuartion))
    resObj.forEach((item) => {
      tmpObj[item.GlobalKey] = item.GlobalValue
    })
    store.commit('setGConfig', res.data.configuartion)
    store.commit('setMainColor', tmpObj.ButtonColor)
    // 判断展会是否关闭
    closeRes(gconfig.value.RegistStopTime)
    // closeRes('2023-02-04 14:00:00')
    if (isWeX.value) {
      wx.getWXSign()
    }
  }
}
const isClose = ref(false)
const closeRes = (str) => {
  const val = str.replace(/-/g, '/')
  isClose.value = new Date().getTime() >= new Date(val).getTime()
}
const downTime = (time) => {
  const timer = setInterval(() => {
    if (time > 0) {
      time--
      btnTxt.value = `${time}s`
    } else {
      btnTxt.value = '发送验证码'
      clearInterval(timer)
    }
  }, 1000)
}
const btnTxt = ref('发送验证码')
const getSms = () => {
  loginForm.value.validate('mobile').then((valid) => {
    if (!valid) {
      api
        .getSmsCodeApi({
          mobile: form.value.mobile,
          token: token.value,
          ExhCode: ExhCode.value
        })
        .then((res) => {
          if (res.code === 200) {
            downTime(60)
            showToast({
              message: '短信验证码已发送成功，请注意查收！',
              wordBreak: 'break-all',
              type: 'success'
            })
          }
        })
    }
  })
}
const getOpenID = () => {
  // 当前链接加获取时间
  const cUrl = window.location.href + '&time=' + Math.round(new Date() / 1000)
  if (isWeX.value) {
   
    if (cUrl.indexOf('openid') === -1) {
  
      if (cUrl.indexOf('InviteType') !== -1) {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}&InviteType=eg`
      } else {
       
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}`
      }
    } else {
      // 如果有openid
      
      store.commit('setOpenID', route.query.openid)
      // 根据openid判断是否注册
      if (openid.value) {
        checkOpenid()
      } 
     // else {
      //  router.go(0)
     // }
    }
  }
}
const checkOpenid = () => {
  api
    .checkIdentityLoginApi({
      openid: openid.value,
      ExhCode: ExhCode.value,
      aliID: ''
    })
    .then((res) => {
      if (res.code === 200) {
        if (res.data) {
          store.commit('setVisitorID', res.data.visitorID)
          sessionStorage.setItem('invitesource', '1')
          sessionStorage.setItem('invitesourceID', res.data.visitorID)
          if (gconfig.value.SuccessPageVersion === 'V2') {
            router.push({ path: '/successV2' })
          } else {
            router.push({ path: '/success' })
          }
        }
      }
    })
}
const tabnow = ref('dl')
const tabChange = (type) => {
  tabnow.value = type
}
const formG = ref({
  Name: '',
  Email: ''
})
// 校验邮箱
const validatorEmail = (val) => {
  return regEmail.test(val)
}
// 校验姓名
const validatorName = (val) => {
  return regName.test(val)
}
const loginFormG = ref()
//  港澳台登录
const onSubmitG = () => {
  loginFormG.value.validate().then((valid) => {
    if (!valid) {
      showLoadingToast({
        message: 'loading...',
        forbidClick: true
      })
      api
        .checkEmailLoginApi({
          Email: formG.value.Email,
          Name: formG.value.Name,
          ExhCode: ExhCode.value
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              // 邮箱已注册
              if (res.data.visitorID) {
                store.commit('setVisitorID', res.data.visitorID)
                if (gconfig.value.SuccessPageVersion === 'V2') {
                  router.push({ path: '/successV2' })
                } else {
                  router.push({ path: '/success' })
                }
              }
            } else {
              sessionStorage.setItem('tabac', tabnow.value)
              store.commit('setLoginForm', formG.value)
              router.push({ path: '/msg' })
            }
          }
        })
    }
  })
}
</script>
<style lang="less">
@import '../../assets/login.less';
.closeTxt {
  padding-top: 100px;
}
.hm {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.loginB {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  .tabs {
    border-bottom: 1px solid #fff;
    width: 90%;
    margin: 0 auto 6px;
    display: flex;
    span {
      display: inline-block;
      flex: 1;
      text-align: center;
      padding: 10px 0;
    }
    .active {
      background: rgba(255, 255, 255, 0.6);
      border-radius: 4px 4px 0 0;
      border-bottom: 2px solid #1989fa;
    }
  }
  .logins {
    padding: 30px 10px 0;
    width: 90%;
    border: 1px solid #eee;
    margin: 52vw auto 0;
    border-radius: 6px;
    background: #fff;
    .loginTit {
      font-size: 5vw;
      padding-bottom: 2vw;
    }
  }
  .loginFormbox {
    .van-button--plain.van-button--primary {
      height: 40px;
      border: 0;
      border-left: 1px solid #666 !important;
      border-radius: 0;
    }
    .van-field__body {
      background: #fff;
    }
    .van-cell-group,
    .van-cell {
      background: transparent;
    }
  }
  .exhName {
    padding: 0 12px 30px;
    line-height: 30px;
  }
  .btnbox {
    padding: 60px 18px 40px;
    .van-button {
      width: 100%;
    }
  }
}
@media screen and (min-width: 768px) {
  .login {
    .loginFormbox {
      .loginTit {
        font-size: 18px;
      }
    }
  }
}
</style>
